import type { ReactNode } from 'react';

import './EmptyState.styl';

type Props = { title: string; hint?: string; action?: ReactNode };

export function EmptyState({ title, hint, action }: Props) {
  return (
    <div className="m-empty">
      <div className="m-empty__title">{title}</div>
      {hint ? <div className="m-empty__hint">{hint}</div> : null}
      {action ? <div className="m-empty__action">{action}</div> : null}
    </div>
  );
}
